/*
* Coarse mobile/desktop guess from a request's User-Agent header, used to pick a plausible
* default viewport for server-side rendering (see useWindowSize.ts) so the first paint on a real
* mobile device already looks roughly right instead of always assuming desktop - avoiding a large
* layout shift once the client corrects to the real viewport after hydration. This is a heuristic,
* not a real viewport measurement (e.g. tablets can go either way), so it only decides the assumed
* breakpoint for the very first render, never true layout logic.
* */
export const isMobileUserAgentHeader = (userAgent?: string | null): boolean => {
    if (!userAgent) return false;
    return /Mobi|Android|iPhone|iPod|Windows Phone|BlackBerry|IEMobile/i.test(userAgent);
};

export const isOldIpad = (): boolean => {
    if (typeof navigator === "undefined") return false;

    const userAgent = navigator.userAgent || navigator.vendor;
    const isIpad = /iPad/.test(userAgent) ||
        (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);

    if (!isIpad) return false;

    // Versuche, die iOS-Version aus "OS X_Y" zu extrahieren
    let match = userAgent.match(/OS (\d+)_/);
    let iosVersion = match ? parseInt(match[1], 10) : null;

    // Falls keine iOS-Version gefunden wurde, als Fallback Safari-Version analysieren
    if (iosVersion === null) {
        match = userAgent.match(/Version\/(\d+)\./);
        iosVersion = match ? parseInt(match[1], 10) : null;
    }

    return iosVersion !== null ? iosVersion <= 13 : false; // Falls keine Version erkannt wird, als neu betrachten
};
